<div class="actionConfrimModal">
  <p-dialog [(visible)]="displayMultiConfirmReplay"
            [closable]="true"
            [header]="modalTitle" (onHide)="closeComponent()"
            [draggable]="false"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false">

<div class="grid numberOfImpactedFolds">
      <div class="col-12 right">
        <p>{{ 'FOLD.ACTION_COMPONENT.ACTION_CONFIRM_IMPACTED' | translate }}: {{this.folds.length}}/{{total}}</p>
        <p *ngIf="notApplicable > 0">{{ 'FOLD.ACTION_COMPONENT.ACTION_NA_FOR_FOLD' | translate }}: {{notApplicable}}</p>
      </div>
    </div>

    <div class="grid">
      <h3>{{ 'FOLD.ACTION_COMPONENT.ACTION_CONFIRM_REASONS' | translate }}</h3>
    </div>
    <div class="grid">
      <textarea pInputTextarea [(ngModel)]="justification" rows="10" cols="50"></textarea>
    </div>


    <div class="col-12 center buttonSpecific">
      <button [disabled]="this.folds.length===0" pButton type="button" (click)="processRequest()"
              [label]="buttonLabel" class="p-button-success"></button>
    </div>

  </p-dialog>
</div>
